import { css } from 'styled-components';
import { GanttBarColors } from 'components/colors';

const ProjectTimeline = css`
  .b-sch-event-wrap.project-timeline {
    height: 6px;
    .content {
      visibility: hidden;
      color: var(--white-100);

      .label {
        color: var(--cyan-20);
        font-size: var(--font-size-base);
      }
      .value {
        color: var(--white-100);
      }
    }
    .b-sch-event {
      background-color: var(--cyan-50);
      border-color: var(--cyan-50);
      &:hover {
        background-color: var(--cyan-60);
        border-color: var(--cyan-60);
      }
    }
    &.collapsed {
      height: 32px;
      transform: translateY(16px);
      .content {
        visibility: visible;
      }
    }
    .b-sch-event-content {
      width: unset;

      .content {
        width: unset;
      }
    }
  }
`;
const ProjectPhases = css`
  .b-sch-event-wrap.project-phase {
    ${GanttBarColors.map(
      (colorName) => css`
        &.${colorName} {
          .b-sch-event {
            background-color: var(--${colorName}-40);
            border-color: var(--${colorName}-40);
            &:hover {
              background-color: var(--${colorName}-50);
              border-color: var(--${colorName}-50);
            }
            .content {
              color: var(--${colorName}-90);
            }
          }
        }
      `,
    )};
    ${[...Array(56)].map(
      (_, index) =>
        css`
          &.height-${index + 1} {
            height: ${index + 1}px;
          }
          &.top-${index + 1} {
            transform: translateY(${index + 1}px);
          }
        `,
    )};
    &.collapsed {
      visibility: hidden;
    }
    .b-sch-event-content {
      width: unset;

      .content {
        width: unset;
      }
    }
  }
`;

export const ProjectEventStyles = css`
  ${ProjectTimeline};
  ${ProjectPhases};
`;
